(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icon-text-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
 
    new Splide('#iconTextSlider', {
      type: 'loop',
      perPage: 2,
      gap: '10px',
      pagination: true,
      arrows: false,
      autoplay: true,
      interval: 7000,
    }).mount();
  
});


  } catch(e) { console.error(e); }
})();
})();
